import { createContext, useContext, type ReactNode } from 'react'

/** What a block needs from the message around it. */
export interface UiBlockHost {
  /** The reply is still arriving. */
  live: boolean
  /** Renders fallback markdown the way the message would. */
  renderMarkdown: (markdown: string) => ReactNode
}

export const UiBlockHostContext = createContext<UiBlockHost>({
  live: false,
  renderMarkdown: (markdown) => markdown,
})

export const useUiBlockHost = () => useContext(UiBlockHostContext)

/** Called by a component that crashed: the whole block falls back to markdown. */
export const UiBlockFailContext = createContext<(error: unknown) => void>(() => {})
